module.exports = __webpack_public_path__ + "assets/img/icon05.0e35a391.png";